export default {
    5937: {
        data: {
            getIssue: {
                id: 5937,
                code: 1,
                priority: 'high',
                title: 'Fechamento Dry-wall',
                text: 'Verificar interferência de tubulação hidráulica com tubulação elétrica.\nAnálise junto ao Matheus, nosso projetista HIDRO/ELE.',
                status: 'in_review',
                due_days: 0,
                due_date: '18/11/2021',
                type: {
                    id: 977,
                    label: 'Ação',
                    name: 'Reparar',
                },
                cause: {
                    id: 652,
                    label: 'Projeto',
                    name: 'Conflito entre projetos',
                },
                sector: {
                    id: 347,
                    name: 'a',
                },
                floorplan: {
                    id: 503,
                    name: '10º Pavimento - ED. Residencial',
                },
                viewpoint: {
                    id: 5282,
                    name: 'Apto 1002 - Área Social',
                },
                image: {
                    id: 10693,
                    date: '29/04/2019 00:00',
                },
                pitch: 6.95426,
                yaw: -30.1698,
                thumbnail:
                    'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F6032ac11-4454-41c0-8c6c-a658d2e4deb6.png?alt=media&token=d651b54c-1936-4562-8384-76e4a8a1bf05',
                attachment_thumbnail: null,
                tags: [
                    {
                        id: 170,
                        members: [
                            {
                                email: 'tales@constructin.com.br',
                            },
                            {
                                email: 'matheus.pandolfo@constructin.com.br',
                            },
                        ],
                    },
                ],
                subjects: [
                    {
                        id: 1174,
                        code: 'ELE',
                        name: 'Elétrica',
                    },
                    {
                        id: 1179,
                        code: 'HID',
                        name: 'Hidrossanitário',
                    },
                ],
                comment_count: 4,
                events: [
                    {
                        id: 13792,
                        type: 'comment',
                        comment: {
                            id: 13792,
                            text: 'Problema resolvido, projeto hidráulico será alterado, conforme anexo.',
                            edited: false,
                            attachments: [],
                        },
                        created_at: '18/11/2021 05:26',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                    {
                        id: 13793,
                        type: 'comment',
                        comment: {
                            id: 13793,
                            text: '',
                            edited: false,
                            attachments: [
                                {
                                    id: 931,
                                    name: 'ProjetoCIN.png',
                                    url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F87b9d228-ace6-4fd0-8c9d-87fe17bf3e06.png?alt=media&token=0edd9318-6dc4-4495-829c-5e31fc088bf3',
                                    type: 'png',
                                },
                            ],
                        },
                        created_at: '18/11/2021 05:26',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                    {
                        id: 13794,
                        type: 'to_review',
                        comment: null,
                        created_at: '18/11/2021 05:27',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                ],
                attachments: [],
                created_at: '17/11/2021 13:39',
                created_by: {
                    id: 657,
                    email: 'owner@constructin.com.br',
                    name: 'Construct IN',
                    surname: '',
                },
                to_review_at: '18/11/2021 05:27',
                closed_at: null,
            },
        },
    },
    5938: {
        data: {
            getIssue: {
                id: 5938,
                code: 2,
                priority: 'high',
                title: 'Requadro janela dormitório',
                text: 'Requadrar janela com acabamento para evitar infiltração.\n\nEm anexo, segue exemplo de instalação correta.\n\nNaomi, empreiteira responsável - cuidar para demais janelas.',
                status: 'open',
                due_days: 1,
                due_date: '19/11/2021',
                type: {
                    id: 970,
                    label: 'Pendência',
                    name: 'Empreiteiro',
                },
                cause: {
                    id: 649,
                    label: 'Qualidade',
                    name: 'Acabamento inadequado',
                },
                sector: {
                    id: 347,
                    name: 'a',
                },
                floorplan: {
                    id: 503,
                    name: '10º Pavimento - ED. Residencial',
                },
                viewpoint: {
                    id: 5293,
                    name: 'Apto 1001 - Dormitório 02',
                },
                image: {
                    id: 10769,
                    date: '29/07/2019 10:33',
                },
                pitch: 9.6782,
                yaw: 10.8491,
                thumbnail:
                    'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F4d552171-de94-4f7e-adf7-c3d2e66a55d2.png?alt=media&token=ee5e34b4-fcc0-43db-b5f6-ec6a3afb0548',
                attachment_thumbnail: null,
                tags: [
                    {
                        id: 170,
                        members: [
                            {
                                email: 'naomi.trindade@constructin.com.br',
                            },
                        ],
                    },
                ],
                subjects: [
                    {
                        id: 1173,
                        code: 'ARQ',
                        name: 'Arquitetura',
                    },
                    {
                        id: 1181,
                        code: 'INT',
                        name: 'Interiores',
                    },
                ],
                comment_count: 1,
                events: [
                    {
                        id: 13786,
                        type: 'comment',
                        comment: {
                            id: 13786,
                            text: 'anotado, requadro realizado',
                            edited: false,
                            attachments: [],
                        },
                        created_at: '17/11/2021 14:21',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                ],
                attachments: [
                    {
                        id: 937,
                        name: 'JanelaCIN.png',
                        url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F67ede576-8f7b-4ba5-b8e5-b88dc1b05592.png?alt=media&token=17c7a789-0dc6-44f4-afd4-e39847ed7017',
                        type: 'png',
                    },
                ],
                created_at: '17/11/2021 13:44',
                created_by: {
                    id: 657,
                    email: 'owner@constructin.com.br',
                    name: 'Construct IN',
                    surname: '',
                },
                to_review_at: null,
                closed_at: null,
            },
        },
    },
    5939: {
        data: {
            getIssue: {
                id: 5939,
                code: 3,
                priority: 'high',
                title: 'Fissura Acabamento',
                text: 'Refazer acabamento de parede.\n\nFissura é superficial, logo é necessário apenas refazer parte do reboco.',
                status: 'closed',
                due_days: 4,
                due_date: '22/11/2021',
                type: {
                    id: 970,
                    label: 'Pendência',
                    name: 'Empreiteiro',
                },
                cause: {
                    id: 649,
                    label: 'Qualidade',
                    name: 'Acabamento inadequado',
                },
                sector: {
                    id: 347,
                    name: 'a',
                },
                floorplan: {
                    id: 503,
                    name: '10º Pavimento - ED. Residencial',
                },
                viewpoint: {
                    id: 5294,
                    name: 'Apto 1001 - Banho Dormitório 02',
                },
                image: {
                    id: 10776,
                    date: '29/07/2019 10:33',
                },
                pitch: -13.0926,
                yaw: 154.441,
                thumbnail:
                    'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F0c7265da-8c53-496e-ae94-611aa8e66e22.png?alt=media&token=383d1796-9087-4623-b81e-d559c4474959',
                attachment_thumbnail: null,
                tags: [
                    {
                        id: 170,
                        members: [
                            {
                                email: 'emilio.bier@constructin.com.br',
                            },
                        ],
                    },
                ],
                subjects: [
                    {
                        id: 1181,
                        code: 'INT',
                        name: 'Interiores',
                    },
                ],
                comment_count: 2,
                events: [
                    {
                        id: 13783,
                        type: 'comment',
                        comment: {
                            id: 13783,
                            text: 'resolvido! Segue foto',
                            edited: false,
                            attachments: [],
                        },
                        created_at: '17/11/2021 14:18',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                    {
                        id: 13784,
                        type: 'comment',
                        comment: {
                            id: 13784,
                            text: '',
                            edited: false,
                            attachments: [
                                {
                                    id: 930,
                                    name: 'image_picker_8A13F896-9997-4049-BD09-9A43C635A0E5-78800-00000D262FF13945.jpg',
                                    url: 'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2Fcd64cb00-2ba1-4d1f-9ae3-e73aa1412e41.txt?alt=media&token=0fa4569a-0fba-4eb6-9863-1ad394e017a6',
                                    type: 'jpeg',
                                },
                            ],
                        },
                        created_at: '17/11/2021 14:20',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                    {
                        id: 13785,
                        type: 'to_review',
                        comment: null,
                        created_at: '17/11/2021 14:20',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                    {
                        id: 13795,
                        type: 'close',
                        comment: null,
                        created_at: '18/11/2021 05:27',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                    {
                        id: 13796,
                        type: 'reopen',
                        comment: null,
                        created_at: '18/11/2021 05:27',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                    {
                        id: 13797,
                        type: 'close',
                        comment: null,
                        created_at: '18/11/2021 05:27',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                ],
                attachments: [],
                created_at: '17/11/2021 13:54',
                created_by: {
                    id: 657,
                    email: 'owner@constructin.com.br',
                    name: 'Construct IN',
                    surname: '',
                },
                to_review_at: null,
                closed_at: '18/11/2021 05:27',
            },
        },
    },
    5940: {
        data: {
            getIssue: {
                id: 5940,
                code: 4,
                priority: 'medium',
                title: 'Organização canteiro',
                text: 'Eng. Leonardo, favor pedir para equipe organizar local de trabalho após terminar serviço.',
                status: 'in_review',
                due_days: 0,
                due_date: '18/11/2021',
                type: {
                    id: 976,
                    label: 'Ação',
                    name: 'Executar',
                },
                cause: {
                    id: 646,
                    label: 'Segurança',
                    name: 'Organização do canteiro',
                },
                sector: {
                    id: 347,
                    name: 'a',
                },
                floorplan: {
                    id: 503,
                    name: '10º Pavimento - ED. Residencial',
                },
                viewpoint: {
                    id: 5272,
                    name: 'Apto 1002 - Dormitório 01',
                },
                image: {
                    id: 10635,
                    date: '29/07/2019 10:30',
                },
                pitch: -54.7041,
                yaw: -8.84038,
                thumbnail:
                    'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F0ba43364-c258-4189-8dc2-ede9a584b7b3.png?alt=media&token=667a9307-6a92-4766-83ef-4afb5bed45b4',
                attachment_thumbnail: null,
                tags: [
                    {
                        id: 170,
                        members: [
                            {
                                email: 'leonardo.henrique@constructin.com.br',
                            },
                        ],
                    },
                ],
                subjects: [],
                comment_count: 2,
                events: [
                    {
                        id: 13782,
                        type: 'comment',
                        comment: {
                            id: 13782,
                            text: 'ótimo ponto, vai ser resolvido ',
                            edited: false,
                            attachments: [],
                        },
                        created_at: '17/11/2021 14:17',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                    {
                        id: 13798,
                        type: 'to_review',
                        comment: null,
                        created_at: '18/11/2021 05:27',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                    {
                        id: 13799,
                        type: 'comment',
                        comment: {
                            id: 13799,
                            text: 'Resolvido!',
                            edited: false,
                            attachments: [],
                        },
                        created_at: '18/11/2021 05:27',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                ],
                attachments: [],
                created_at: '17/11/2021 13:58',
                created_by: {
                    id: 657,
                    email: 'owner@constructin.com.br',
                    name: 'Construct IN',
                    surname: '',
                },
                to_review_at: '18/11/2021 05:27',
                closed_at: null,
            },
        },
    },
    5941: {
        data: {
            getIssue: {
                id: 5941,
                code: 5,
                priority: 'low',
                title: 'Terminabilidade dry-wall',
                text: 'Atentar para armazenamento das esquadrias para não trancar demais serviços, como no exemplo, as janelas não permitiram finalizar tanto a tubulação, quanto o fechamento da parede.',
                status: 'open',
                due_days: -1,
                due_date: '17/11/2021',
                type: {
                    id: 978,
                    label: 'Ação',
                    name: 'Organizar',
                },
                cause: {
                    id: 646,
                    label: 'Segurança',
                    name: 'Organização do canteiro',
                },
                sector: {
                    id: 347,
                    name: 'a',
                },
                floorplan: {
                    id: 503,
                    name: '10º Pavimento - ED. Residencial',
                },
                viewpoint: {
                    id: 5283,
                    name: 'Apto 1001 - Área Social',
                },
                image: {
                    id: 10705,
                    date: '24/06/2019 00:00',
                },
                pitch: -12.5665,
                yaw: -80.5993,
                thumbnail:
                    'https://firebasestorage.googleapis.com/v0/b/constructin-15d0f.appspot.com/o/projects%2Fissues%2F3e504391-385a-4ad5-b1f2-7c6e22cac085.png?alt=media&token=9e288efc-9193-4836-850a-806fa4c6bc83',
                attachment_thumbnail: null,
                tags: [
                    {
                        id: 170,
                        members: [
                            {
                                email: 'tales@constructin.com.br',
                            },
                            {
                                email: 'lucas.pandolfo@constructin.com.br',
                            },
                            {
                                email: 'emilio.bier@constructin.com.br',
                            },
                            {
                                email: 'mario.magela@constructin.com.br',
                            },
                            {
                                email: 'emerson@sqgroup.com.br',
                            },
                            {
                                email: 'kelvin.montini@constructin.com.br',
                            },
                            {
                                email: 'naomi.trindade@constructin.com.br',
                            },
                            {
                                email: 'matheus.pandolfo@constructin.com.br',
                            },
                            {
                                email: 'isis.gonzaga12@gmail.com',
                            },
                            {
                                email: 'ryan.simon@constructin.com.br',
                            },
                            {
                                email: 'jessie.spencer@constructin.com.br',
                            },
                            {
                                email: 'leonardo.henrique@constructin.com.br',
                            },
                            {
                                email: 'lucas.oliveira@constructin.com.br',
                            },
                            {
                                email: 'maria.julia@constructin.com.br',
                            },
                            {
                                email: 'lenon.lencina@constructin.com.br',
                            },
                            {
                                email: 'leonardo.lopes@constructin.com.br',
                            },
                        ],
                    },
                ],
                subjects: [],
                comment_count: 16,
                events: [
                    {
                        id: 13781,
                        type: 'comment',
                        comment: {
                            id: 13781,
                            text: 'entendido, vai ser feito!',
                            edited: false,
                            attachments: [],
                        },
                        created_at: '17/11/2021 14:17',
                        created_by: {
                            id: 657,
                            email: 'owner@constructin.com.br',
                            name: 'Construct IN',
                            surname: '',
                        },
                    },
                ],
                attachments: [],
                created_at: '17/11/2021 14:01',
                created_by: {
                    id: 657,
                    email: 'owner@constructin.com.br',
                    name: 'Construct IN',
                    surname: '',
                },
                to_review_at: null,
                closed_at: null,
            },
        },
    },
}
